/** Config owns its state and behavior; dependencies are passed in by main. */

export function register(app) {
  const { config } = app;
}

/** Initializers are called explicitly, in dependency order, from main. */
export function configureSite(app) {
  const { config } = app;
  config.FORM_ENDPOINT = 'api/contact.php';
  config.BLOG_ENABLED = false;
}
